<template>
  <div>
    <e-dialog
      dialog-title="附件"
      :center-dialog-visible="importMaterialUploadVisible"
      popup-width="600px"
      :show-btn="showBtn"
      :show-close-btn="showCloseBtn"
      @resetPopupData="handleClose"
      @submitPopupData="handleConfirm"
    >
      <tableList
        class="margin-t20"
        row-key="companyId"
        :index-show="true"
        :loading="false"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template #attachmentMust="{ scope: { row } }">
          <span style="color: #f0250f">必传</span>
        </template>
        <template #uploadFileName="{ scope: { row, $index } }">
          <div style="padding: 4px 0">
            <el-upload
              v-if="
                row.importedAttachList.length < 5 && handleFlag === 'upload'
              "
              ref="uploadFile"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :auto-upload="true"
              :on-success="getFileInfo"
              :before-upload="handleBeforeUpload"
            >
              <eui-btn
                icon="eicon-upload"
                icon-position="left"
                type="secondary"
                @click="handleUpload($index)"
                >上传附件
              </eui-btn>
            </el-upload>
            <div
              v-for="(item, index) in row.importedAttachList"
              :key="index"
              class="flex-sc"
              :class="{
                'margin-t10':
                  row.importedAttachList.length > 1 && handleFlag === 'upload',
              }"
            >
              <eui-icon
                icon="eicon-r-l-wenjian"
                font-size="16px"
                style="margin-right: 4px"
              ></eui-icon>
              <div @click="viewFile(item.url)">
                <e-tooltip-over
                  :line="1"
                  :tooltip-style="{
                    width: '180px',
                    color: '#0064c8',
                    height: '16px',
                    cursor: 'pointer',
                  }"
                  :content="item.name"
                >
                </e-tooltip-over>
              </div>

              <div @click="handleDelFile($index, index)">
                <eui-icon
                  v-if="handleFlag === 'upload'"
                  icon="eicon-r-l-guanbi"
                  font-size="14px"
                ></eui-icon>
              </div>
            </div>
          </div>
        </template>
      </tableList>
    </e-dialog>
  </div>
</template>

<script>
import api from '../../api/order';
import eDialog from './e-dialog.vue';
import tableList from './e-table-list';
import eTooltipOver from './e-tooltip-over.vue';
import { epecToken } from '../../utils/globalData';

export default {
  name: 'ContractUpload',
  components: {
    eDialog,
    tableList,
    eTooltipOver,
  },
  props: {
    importMaterialUploadVisible: Boolean,
    handleFlag: String,
    viewContractAttachData: Array,
  },
  data() {
    return {
      showCloseBtn: false,
      showBtn: true,
      fileIndex: null,
      uploadUrl: api.orderAttachUpload,
      headers: epecToken,
      queryData: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      //  4:过程控制报告;5:原厂授权书;6:原始报关单
      tableData: [
        { listName: '过程控制报告', importedAttachList: [] },
        {
          listName: '原厂授权书（进口原材料、关键零部件）',
          importedAttachList: [],
        },
        { listName: '原始报关单', importedAttachList: [] },
      ],
      tableLabel: [
        {
          label: '交付资料清单',
          param: 'listName',
          align: 'center',
          width: '100',
        },
        {
          label: '是否必传',
          param: '',
          align: 'center',
          width: '80',
          slot: 'attachmentMust',
        },
        { label: '文件名称', param: '', align: 'left', slot: 'uploadFileName' },
      ],
    };
  },
  mounted() {
    console.log(this.handleFlag, this.viewContractAttachData, 'ffffff');
    if (this.handleFlag === 'view') {
      this.showCloseBtn = true;
      this.showBtn = false;
    }
    if (this.viewContractAttachData.length > 0) {
      this.tableData = this.viewContractAttachData;
    }
  },
  methods: {
    viewFile(url) {
      window.open(url);
    },
    handleDelFile(tableIndex, fileIndex) {
      this.tableData[tableIndex].importedAttachList.splice(fileIndex, 1);
    },
    handleUpload(index) {
      this.fileIndex = index;
    },
    handleBeforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 200) {
        this.$message({ message: '附件不能超过200M。', type: 'warning' });
        return false;
      }
      return true;
    },
    getFileInfo(res, file) {
      if (this.tableData[this.fileIndex].importedAttachList.length === 5) {
        this.$message.warning({ message: '只能上传五个附件。' });
        return false;
      }
      //  4:过程控制报告;5:原厂授权书;6:原始报关单
      if (res.success) {
        const params = {
          url: file.response.data.url,
          name: file.name,
          type: this.fileIndex === 0 ? 4 : this.fileIndex === 1 ? 5 : 6,
        };
        this.tableData[this.fileIndex].importedAttachList.push(params);
      }
    },
    handleConfirm() {
      if (this.tableData[0].importedAttachList.length === 0) {
        this.$message.warning({ message: '请上传过程控制报告附件。' });
        return false;
      }
      if (this.tableData[1].importedAttachList.length === 0) {
        this.$message.warning({ message: '请上传原厂授权书附件。' });
        return false;
      }
      if (this.tableData[2].importedAttachList.length === 0) {
        this.$message.warning({ message: '请上传原始报关单附件。' });
        return false;
      }
      console.log(this.tableData);
      this.$emit('dealImportMaterialAttachData', this.tableData);
      this.handleClose();
    },
    handleClose() {
      this.$emit('update:importMaterialUploadVisible', false);
    },
  },
};
</script>

<style scoped></style>
